import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  getClientIkCardSelectableIconItemForManageProductFull
} from '@app/invitation/invitation-b2b/shared/helpers/ik-card-selectable-icon-item/client/get-client-ik-card-selectable-icon-item-for-manage-product-full';
import {
  getClientIkCardSelectableIconItemForManageProductLimited
} from '@app/invitation/invitation-b2b/shared/helpers/ik-card-selectable-icon-item/client/get-client-ik-card-selectable-icon-item-for-manage-product-limited';
import {
  getClientIkCardSelectableIconItemForManageUsers
} from '@app/invitation/invitation-b2b/shared/helpers/ik-card-selectable-icon-item/client/get-client-ik-card-selectable-icon-item-for-manage-users';
import {
  getClientIkCardSelectableIconItemForOrdersAndRenewals
} from '@app/invitation/invitation-b2b/shared/helpers/ik-card-selectable-icon-item/client/get-client-ik-card-selectable-icon-item-for-orders-and-renewals';
import { IInvitation } from '@app/models/signup';
import { IIkCardSelectableIconItem, } from '@infomaniak/angular-common/src/components/ik-card-selectable-icon-item/ik-card-selectable-icon-item.interfaces';
import { translate, TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-invitation-b2b-client-access-list',
  templateUrl: './invitation-b2b-client-access-list.component.html',
  styleUrls: ['./invitation-b2b-client-access-list.component.scss']
})
export class InvitationB2bClientAccessListComponent implements OnInit {
  @Input() invitation: IInvitation;
  @Input() selectedAccount;
  @Output() permissionSelected = new EventEmitter();

  limitedAccess: IIkCardSelectableIconItem[];
  fullAccess: IIkCardSelectableIconItem[];

  selectedPermission: 'limited' | 'full';

  constructor(
    protected domSanitizer: DomSanitizer,
    private translocoService: TranslocoService
    // protected router: Router,
  ) {
    this.limitedAccess = [];
    this.fullAccess = [];
  }

  get wantFullAccess(): boolean {
    return this.invitation.extras.full_access;
  }

  get custom(): any {
    return translate('Commandes et renouvellements');
  }

  ngOnInit(): void {
    // if selectedAccount.in_partnership_limited, the current org cannot have full + limited, it has to be a limited
    this.selectedPermission = this.selectedAccount.in_partnership_limited ? 'limited' :
      (this.invitation.extras.full_access ? 'full' : 'limited');

    if (this.selectedAccount.in_partnership_limited && !this.invitation.extras.full_access) {
      // avoid changed during lifecycle error
      setTimeout(() => {
        this.permissionSelected.emit(this.selectedPermission);
      });
    }

    this.translocoService.langChanges$.subscribe(() => {
      this.limitedAccess = [
        getClientIkCardSelectableIconItemForManageProductLimited(),
        {
          ...getClientIkCardSelectableIconItemForManageUsers(),
          disabled: true,
        },
        {
          ...getClientIkCardSelectableIconItemForOrdersAndRenewals(),
          disabled: true,
        },
      ];

      this.fullAccess = [
        getClientIkCardSelectableIconItemForManageProductFull(),
        getClientIkCardSelectableIconItemForManageUsers(),
        getClientIkCardSelectableIconItemForOrdersAndRenewals(),
      ];
    });
  }

  switchPermission(permission: 'limited' | 'full'): void {
    this.selectedPermission = permission;
    this.permissionSelected.emit(this.selectedPermission);
  }
}
